import React, { useEffect } from 'react';
import { URLS } from '@wix/da-url';
import { ReportSectionForms, ReportSectionTypes } from '../redux/constants';
// eslint-disable-next-line @wix/da/scss-same-filename-as-module
import s from '../ReportPage.scss';
const ReportThirdPartyViolation = ({ onMount })=>{
    useEffect(()=>{
        onMount(ReportSectionForms[ReportSectionTypes.ThirdPartyIp], ReportSectionTypes.ThirdPartyIp);
    }, [
        onMount
    ]);
    return /*#__PURE__*/ React.createElement("ul", {
        className: s['section']
    }, /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement("p", null, "This deviation uses someone else’s intellectual property without the rights to do so.", ' ', /*#__PURE__*/ React.createElement("i", null, "Copyright owners should use “This is my Intellectual Property.”")), /*#__PURE__*/ React.createElement("p", null, "If you believe this deviation is using someone else’s content without permission, please read through", ' ', /*#__PURE__*/ React.createElement("a", {
        href: "https://protectart.deviantart.com/journal/The-Art-Theft-Discussion-544490149",
        target: "_blank",
        rel: "noreferrer",
        className: "text-link-level-2-primary"
    }, "this helpful set of journals"), ' ', "since they may resolve many of the questions you may have."), /*#__PURE__*/ React.createElement("p", null, "DeviantArt protects the rights of artists and maintains", ' ', /*#__PURE__*/ React.createElement("a", {
        href: URLS.COPYRIGHT,
        target: "_blank",
        rel: "noreferrer"
    }, "the following Copyright Policy"), ". If you believe this deviation is using third-party content which you yourself do not own or control, you may still comment under the deviation, if you wish, recommending to the deviant that they consult DeviantArt’s", ' ', /*#__PURE__*/ React.createElement("a", {
        href: "https://protectart.deviantart.com/journal/The-Art-Theft-Discussion-544490149",
        target: "_blank",
        rel: "noreferrer",
        className: "text-link-level-2-primary"
    }, "journal on art theft.")), /*#__PURE__*/ React.createElement("p", null, "Thank you for your membership in DeviantArt and your continued commitment to the community.")));
};
ReportThirdPartyViolation.displayName = 'ReportIpViolation';
export default ReportThirdPartyViolation;

//# sourceMappingURL=ReportThirdPartyViolation.js.map